import * as React from 'react';
import MDialog from '../../../components/controls/MDialog';
import { Button } from '@mui/material';
import MSelect from '../../../components/controls/MSelect';
import { IChoice } from '../types';

/** Props for {@link EntryDatePopup}. */
export interface IEntryDatePopupProps {
    /** Whether the dialog is visible. */
    open: boolean;
    /** `EntryDate` choices the user must pick from. */
    dates: IChoice[];
    /** Called when the dialog is dismissed without a selection. */
    onClose: () => void;
    /** Called with the selected date id when the user confirms. */
    onSelect: (value: string | number) => void;
}

/**
 * Prompts the user to pick one of the `EntryDate` values found in the rule's
 * condition, when a condition references `EntryDate` but no expiration date
 * has been set yet (see `RuleEditPopup`'s `validateExpiresAt`).
 * @param props - `open`, `dates` (choices), `onClose`, and `onSelect` callbacks.
 */
const EntryDatePopup: React.FC<IEntryDatePopupProps> = ({ open, dates, onClose, onSelect }) => {
    const [entryDate, setEntryDate] = React.useState<string | number>(dates[0].id);

    return (
        <MDialog open={open}
            handleClose={onClose}
            title={'The condition contains [EntryDate] rules so that you have to select expiring dates.'}
            action={<Button variant="contained" onClick={() => onSelect(entryDate)}>Select</Button>}>
            <MSelect
                defaultValue={dates[0].id}
                choices={dates}
                isEmptyOption={false}
                onChange={setEntryDate} />
        </MDialog>
    );
};

export default EntryDatePopup;
